// extracted by mini-css-extract-plugin
module.exports = {"categories":"styles_categories__mTD4r","category":"styles_category__2Ohru","categoryName":"styles_categoryName__3zxTr"};